import { onConnect } from '@sonicgarden/onconnect';

$('.js-tour-schedules').on('cocoon:after-insert', (e, $insertedItem) => {
  const $dateInputs = $insertedItem.closest('.js-tour-schedules').find('.nested-fields:visible input[type="date"]');
  const dateInput = $dateInputs[$dateInputs.length - 2];
  if (dateInput) {
    $insertedItem.find('input[type="date"').val(dateInput.value);
  }
});

onConnect('.js-add-tour-schedule-link', (link) => {
  $(link).data('association-insertion-node', (link) => link.closest('.nested-fields').find('.js-tour-schedules'));
});
